<template>
  <div>
    <span v-if="step === 'age'"> You are {{ profile.bornAt | inWords }} old </span>

    <span v-if="step === 'experience'">
      You have listed {{ experienceCount }}
      {{ experienceCount | pluralize('experience') }}
    </span>

    <span v-if="step === 'gender'">You identify as {{ profile.gender.toLowerCase() }}</span>

    <span v-if="step === 'location'">You currently live in {{ profile.location.address }}</span>

    <span v-if="step === 'nationality'" class="text-vertical-middle">
      Your nationality is
      <img
        v-if="profile.countryOfBirth"
        :class="`flag-icon flag-icon-${profile.countryOfBirth.toLowerCase()}`"
        style="padding: 0 12px 12px 14px"
      />
    </span>

    <span v-if="step === 'qualifications'">
      You have listed {{ qualificationsCount }}
      {{ qualificationsCount | pluralize('qualification') }}
    </span>

    <span v-if="step === 'professional_qualifications'">
      You have listed {{ professionalQualificationsCount }}
      {{ professionalQualificationsCount | pluralize('qualification') }}
    </span>

    <span v-if="step === 'study_right'">
      You have study rights in
      <span
        v-for="(right, i) in profile.workRights"
        :key="`work-right-${i}`"
        :class="`flag-icon flag-icon-${right.countryCode.toLowerCase()}`"
      />
    </span>

    <span v-if="step === 'work_right'">
      You have work rights in
      <span
        v-for="(right, i) in profile.workRights"
        :key="`work-right-${i}`"
        :class="`flag-icon flag-icon-${right.countryCode.toLowerCase()}`"
      />
    </span>
  </div>
</template>

<script>
  import _ from 'lodash'

export default {
  created() {
    if (this.step === 'qualifications') {
      this.$store.dispatch('candidate/profileQualifications/fetchAll')
    }
    if (this.step === 'experience') {
      return this.$store.getters['candidate/experiences/all']
    }
  },

  props: {
    profile: { type: Object, required: true },
    step: String,
  },

  data() {
    return {}
  },

  computed: {
    experiences() {
      return this.$store.getters['candidate/experiences/all']
    },

    experienceCount() {
      if (!this.experiences) return 0
      return this.experiences.length
    },

    qualifications() {
      return this.$store.getters['candidate/profileQualifications/all']
    },

    professionalQualifications() {
      if (!this.qualifications) return []
      return this.qualifications.filter(q =>  {
        return _.get(q, 'qualification.qualificationType.qualificationCategory.name') ===
        'Professional Qualification'
      })
    },

    qualificationsCount() {
      if (!this.qualifications) return 0
      return this.qualifications.length
    },

    professionalQualificationsCount() {
      if (!this.professionalQualifications) return 0
      return this.professionalQualifications.length
    },
  },
}
</script>
